/* eslint-disable comma-dangle */
/* eslint-disable max-len */
/* eslint-disable no-invalid-this */
/* eslint-disable no-unused-vars */

import validate from 'jquery-validation';

$(document).ready(function() {
    // wpcSubmissionFormPage
	const wpcSubmissionFormPage = $('.wpcSubmissionFormPage');

    wpcSubmissionFormPage.find('form').validate(
        {
            errorClass: 'is-invalid',
            errorElement: 'div',
            highlight: function(element, errorClass) {
                // Override the default behavior here
            },
            errorPlacement: function(error, element) {
                if (element.is('[type="radio"]')) {
                    error.insertAfter(element.closest('.options-group'));
                } else if (element.is('[type="checkbox"]')) {
                    error.insertAfter(element.closest('.form-group').find('label'));
                } else {
                    error.insertAfter(element.closest('.form-group').find('input, select'));
                }
            }
        }
    );

    wpcSubmissionFormPage.on('click', 'button[type="submit"]', function(e) {
        e.preventDefault();

        const $form = wpcSubmissionFormPage.find('form');

        if ($form.valid()) {
            $form.submit();
        } else {
            $('html, body').animate({
                scrollTop: $(document).find('.is-invalid:visible').first().closest('.form-group').offset().top - 140 // header height
            }, 500);
        }
    });

    // re-trigger validation
    wpcSubmissionFormPage.find('form').find('input, select').each(function() {
        $(this).on('change', function() {
            $(this).blur().focus();
        });
	});
});
